export default {
	getaccessrecord: '/website/visit/get_recently_website_visit', //获取最近网页访问记录-数据看板
	getaccessrecordPage: '/website/visit/get_website_visit?serviceSiteId={serviceSiteId}', //网站访问记录列表
	getInquCusinfo: '/website/visit/inquiry_customer_info', //获取询盘/客户信息
	getaccessrecordPageList: '/website/visit/get_wbWebsite_visit_detail?serviceSiteId={serviceSiteId}', //获取网站访问记录页面里的列表中扩展列表信息
	downWebsiteVisit: '/website/visit/down_website_visit', //下载
	downloadwebsitevisit: '/website/visit/downloadwebsitevisit?serviceSiteId={serviceSiteId}', //下载
	//国家地区
	countryList: '/geotargets/list', //todo跟换地区数据

};
